/* SENSEZ · Neutraliza urgencia falsa de apps de terceros (Etapa 1).
   Essential Cart muestra "Este precio expira en MM:SS" en su drawer; el precio no expira. Se oculta solo esa franja,
   buscándola por su texto (las clases de la app se generan automáticamente y pueden cambiar).
   Solución definitiva: desactivar el temporizador en la configuración de Essential Cart. */
(() => {
  const PATRON = /^\s*Este precio expira en\s*[\d:\s]*$/i;
  function ocultarTemporizador(raiz) {
    const nodos = (raiz || document).querySelectorAll('#essential-cart-drawer-portal p, #essential-cart-drawer-portal span');
    nodos.forEach((n) => {
      if (!/Este precio expira/i.test(n.textContent || '')) return;
      let fila = n;
      while (fila.parentElement && fila.parentElement.id !== 'essential-cart-drawer-portal' && PATRON.test(fila.parentElement.innerText || '')) {
        fila = fila.parentElement;
      }
      if (fila.style.display !== 'none') fila.style.display = 'none';
    });
  }
  let pendiente = null;
  new MutationObserver(() => {
    if (pendiente) return;
    pendiente = requestAnimationFrame(() => { pendiente = null; ocultarTemporizador(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
